import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';

import {WHITE_100} from '../../../theme';

const styles = {
  modal: {
    base: {
      borderRadius: '0.5rem',
      boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
      backgroundColor: WHITE_100,
      minHeight: '220px',
    },
    container: {
      padding: '1.5rem',
    },
    title: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignSelf: 'stretch',
      color: '#162523',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '150%',
      letterSpacing: '-0.14px',
      maxHeight: '30vh',
      overflowY: 'auto',
    },
    table: {
      minWidth: 450,
      th: {
        fontWeight: 700,
        fontSize: '0.825rem',
      },
      td: {
        fontSize: '0.825rem',
        verticalAlign: 'top',
        reason: {
          maxHeight: 200,
          overflow: 'auto',
        },
        emails: {},
      },
    },
    divider: {
      marginBlock: '0.5rem',
    },
  },
};

const FailedInvitesDialog = ({open, onClose, failedDetails}) => {
  const theme = useTheme();

  // Group emails by failure reason for a more compact display
  const failuresByReason = useMemo(() => {
    const reasonMap = new Map();

    failedDetails.forEach(({email, messages}) => {
      messages.forEach((reason) => {
        if (!reasonMap.has(reason)) {
          reasonMap.set(reason, []);
        }
        reasonMap.get(reason).push(email);
      });
    });

    return Array.from(reasonMap.entries()).map(([reason, emails]) => ({
      reason,
      emails,
    }));
  }, [failedDetails]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={styles.modal.title}>
        Some invitations could not be sent
      </DialogTitle>
      <DialogContent dividers sx={styles.modal.container}>
        <Table size="small" sx={styles.modal.table}>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.modal.table.th}>Emails</TableCell>
              <TableCell sx={styles.modal.table.th}>
                Reason for Failure
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {failuresByReason.map(({reason, emails}) => (
              <TableRow key={reason}>
                <TableCell sx={styles.modal.table.td.emails}>
                  {emails.map((email, idx) => (
                    <div key={idx}>{email}</div>
                  ))}
                </TableCell>
                <TableCell sx={styles.modal.table.td.reason}>
                  {reason}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={theme.button.primary.small}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FailedInvitesDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  failedDetails: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      messages: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ).isRequired,
};

export default FailedInvitesDialog;
